window.addEventListener('load', () => {
  const loader = document.querySelector('.loader');
  if (!loader) {
    window.dispatchEvent(new CustomEvent('app:loaderHidden'));
    return;
  }

  // If a .scrolling-video-cards section exists, gate on ALL its videos (both background + box videos).
  const scrollingSection = document.querySelector('.scrolling-video-cards');
  let gatedVideos = [];
  if (scrollingSection) {
    gatedVideos = Array.from(scrollingSection.querySelectorAll('video'));
    console.log('[loader] gating on scrolling-video-cards videos count =', gatedVideos.length);
  } else {
    // Backward compatibility: just use the trailer-box-video set (if any)
    gatedVideos = Array.from(document.querySelectorAll('video.trailer-box-video'));
  }
  if (!gatedVideos.length) {
    simpleHide();
    return;
  }

  // Maximum time (ms) to wait before forcing hide (network stalls, etc.)
  const FORCE_HIDE_TIMEOUT = 10000;
  const MIN_SHOW_TIME = 650; // maintain original aesthetic delay before fade start
  const FADE_DURATION = 700; // must match CSS transition
  const READINESS_READY_STATE = 4; // require HAVE_FUTURE_DATA (was 2)

  let forceHideTimer;
  let minShowTimer;
  let earliestFadeReady = false;
  let videosReady = false;
  let hidden = false;

  function maybeHide() {
    if (hidden) return;
    if (!earliestFadeReady || !videosReady) return;
    hidden = true;
    clearTimeout(forceHideTimer);
    fadeOutAndHide();
  }

  function fadeOutAndHide() {
    loader.classList.add('fade-out');
    setTimeout(() => {
      loader.style.display = 'none';
      window.__loaderHiddenFired = true;
      window.dispatchEvent(new CustomEvent('app:loaderHidden'));
    }, FADE_DURATION);
  }

  function simpleHide() {
    setTimeout(() => {
      loader.classList.add('fade-out');
      setTimeout(() => {
        loader.style.display = 'none';
        window.__loaderHiddenFired = true;
        window.dispatchEvent(new CustomEvent('app:loaderHidden'));
      }, FADE_DURATION);
    }, MIN_SHOW_TIME);
  }

  // Promise for each video with stall grace & single resolution (used per unique source primary).
  function videoReadyPromise(video, idx, totalLabelCount) {
    const label = `src#${idx+1}/${totalLabelCount}`;
    try { video.dataset.initialReadyState = String(video.readyState); } catch(e) {}
    const STALL_GRACE_MS = 1500;
    return new Promise(resolve => {
      let resolved = false;
      let stallTimer = null;
      const resolveOnce = (path, degraded=false) => {
        if (resolved) return;
        resolved = true;
        if (stallTimer) clearTimeout(stallTimer);
        video.dataset.readyPath = path + (degraded ? '-degraded' : '');
        resolve();
      };

      if (video.readyState >= READINESS_READY_STATE) {
        console.log('[loader] video already ready (>=', READINESS_READY_STATE, ')', label, extractVideoName(video), 'readyState=', video.readyState);
        resolveOnce('immediate-readyState');
        return;
      }

      const onProgress = (ev) => {
        if (resolved) return;
        if (video.readyState >= READINESS_READY_STATE) {
          console.log('[loader] video ready via', ev.type, '(>=', READINESS_READY_STATE, ')', label, extractVideoName(video), 'readyState=', video.readyState);
          cleanup();
          resolveOnce(ev.type);
        }
      };
      const onError = (ev) => {
        if (resolved) return;
        console.warn('[loader] video error', ev.type, label, extractVideoName(video), 'readyState=', video.readyState);
        cleanup();
        resolveOnce(ev.type + '-error', true);
      };
      const onStall = (ev) => {
        if (resolved) return;
        console.warn('[loader] video stalled', label, extractVideoName(video));
        if (!stallTimer) {
          stallTimer = setTimeout(()=>{
            if (resolved) return;
            console.warn('[loader] stall grace exceeded; marking degraded', label, extractVideoName(video));
            cleanup();
            resolveOnce('stalled-timeout', true);
          }, STALL_GRACE_MS);
        }
      };
      function cleanup() {
        video.removeEventListener('loadedmetadata', onProgress);
        video.removeEventListener('canplay', onProgress);
        video.removeEventListener('canplaythrough', onProgress);
        video.removeEventListener('error', onError);
        video.removeEventListener('abort', onError);
        video.removeEventListener('stalled', onStall);
        video.removeEventListener('suspend', onStall);
      }
      video.addEventListener('loadedmetadata', onProgress, { passive: true });
      video.addEventListener('canplay', onProgress, { passive: true });
      video.addEventListener('canplaythrough', onProgress, { passive: true });
      video.addEventListener('error', onError, { once: true });
      video.addEventListener('abort', onError, { once: true });
      video.addEventListener('stalled', onStall);
      video.addEventListener('suspend', onStall);
      console.log('[loader] watching video', label, extractVideoName(video), 'initial readyState=', video.readyState);
    });
  }

  // Helper: get readable file name / last path segment
  function extractVideoName(video){
    try {
      const src = video.currentSrc || video.src || '';
      if (!src) return '(no src)';
      const parts = src.split('?')[0].split('/');
      return parts[parts.length-1] || src;
    } catch(e){ return '(unknown)'; }
  }

  // --- UNIQUE SOURCE GROUPING ---
  const bySrc = new Map(); // cleanedSrc -> { elements: [], promise }
  function cleanSrc(el){
    const raw = (el.currentSrc || el.src || '').split('#')[0];
    return raw.split('?')[0];
  }
  gatedVideos.forEach(v => {
    const key = cleanSrc(v);
    if (!bySrc.has(key)) bySrc.set(key, { elements: [] });
    bySrc.get(key).elements.push(v);
  });
  const uniqueEntries = Array.from(bySrc.entries());
  console.log(`[loader] unique video sources: ${uniqueEntries.length} (elements: ${gatedVideos.length})`);

  let sourcesReadyCount = 0;
  function incrementReadySource(key, path){
    sourcesReadyCount++;
    console.log(`[loader] source ready ${sourcesReadyCount}/${uniqueEntries.length} :: ${key} (${path})`);
    if (sourcesReadyCount === uniqueEntries.length) {
      console.log('[loader] all unique video sources ready');
    }
  }

  // Wrap existing per-element logic but only count once per src
  const sourcePromises = uniqueEntries.map(([key, group], idx) => {
    // Use first element as representative
    const primary = group.elements[0];
    return videoReadyPromise(primary, idx, uniqueEntries.length).then(()=>{
      const path = primary.dataset.readyPath || 'unknown';
      // Propagate path to others (for summary table)
      group.elements.forEach((el,i)=>{ if (i>0 && !el.dataset.readyPath) el.dataset.readyPath = 'shared-'+path; });
      incrementReadySource(key, path);
    });
  });

  Promise.all(sourcePromises).then(()=>{
    videosReady = true;
    try {
      const summary = gatedVideos.map((v,i)=>({
        index: i+1,
        name: extractVideoName(v),
        src: cleanSrc(v),
        initialReadyState: v.dataset.initialReadyState,
        path: v.dataset.readyPath || 'unknown'
      }));
      console.table(summary);
    } catch(e) {}
    maybeHide();
  });

  // Maintain minimum loader display duration
  minShowTimer = setTimeout(() => { earliestFadeReady = true; maybeHide(); }, MIN_SHOW_TIME);

  // Force hide after timeout regardless of state
  forceHideTimer = setTimeout(() => {
    if (hidden) return;
    console.warn('[loader] Force hiding after timeout; some videos may not have loaded.');
    videosReady = true; // allow maybeHide to proceed
    earliestFadeReady = true;
    maybeHide();
  }, FORCE_HIDE_TIMEOUT);
});